
import "D:/A.Git/松溪政协/fs-sxzx-web/src/components/RightContent/index.less?modules";
export default {"account": `account-2ivdzicH`,"userIcon": `userIcon-WBWw61JM`,"search": `search-lNu2E5Vr`,"avatar": `avatar-MzuL6tAg`,"menu": `menu-2znavVGV`,"right": `right-Tr0kHMQS`,"action": `action-E306zAEF`,"name": `name-Wj1CKFvD`}
